import styled from "styled-components";
import { useEffect, useState } from "react";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Contractor } from "../../../../services/subcontractor/get-all/types";
import { Button } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getAllSubcontractor } from "../../../../services/subcontractor/get-all";
import { SubcontractorAdresEdite } from "../../../operator-views/operator-subcontractors-detail-edite/components/forms/adres-edite";
import { GoBackButton } from "../../../../components/GoBackButton";
import { urlSubcontractor } from "../../../../utils/url";
import { StyledTable } from "../../../../components/table/styled-table";
import { OperatorSubcontractorDetailEdite } from "../../../operator-views/operator-subcontractors-detail-edite";
import { LoadingBackDrop } from "../../../../components/loader";
import { SubcontractorDataEdite } from "../../../operator-views/operator-subcontractors-detail-edite/components/forms/data-edite";
import SessionService from "../../../../services/session-service";
import { WarehousesContractors } from "../../../../services/warehouses/get-all/types";

export const SubcontractorsDetails = () => {
  const [subcontractorData, setSubcontractorData] = useState(
    SessionService.getLoggedUserData()
  );

  const columns: GridColDef[] = [
    {
      field: "subcontractor_name",
      headerName: "Nazwa",
      width: 200,
      sortable: false,
      filterable: false,
      hideable: false,
    },
    { field: "subcontractor_phone", headerName: "Telefon", width: 150 },
    { field: "subcontractor_email", headerName: "E-mail", width: 200 },
  ];

  // const [subcontractors, setSubcontractors] = useState<Contractor[]>([]);

  // const body = {
  //   paginacja: null,
  // };

  // const GetAllSubcontractor = useQuery(
  //   ["AllSubcontractor"],
  //   () => getAllSubcontractor(body),
  //   {
  //     refetchOnMount: true,
  //     refetchOnWindowFocus: false,
  //     onSuccess(data) {
  //       setSubcontractors(data.data.payload.wykonawcy);
  //     },
  //   }
  // );
  // const subcontractorsFromLocalStorage = SessionService.getSubcontractors();
  // const subcontractorsIdArray = subcontractorsFromLocalStorage.map(
  //   (item: WarehousesContractors) => item.id_wykonawcy
  // );
  // const filteredSubcontractors: Contractor[] | undefined =
  //   subcontractors.filter((item: Contractor) =>
  //     subcontractorsIdArray.includes(item.id)
  //   );

  // useEffect(() => {}, [filteredSubcontractors]);

  const rows = [
    {
      id: subcontractorData.id_wykonawca,

      subcontractor_name: subcontractorData.nazwa,

      subcontractor_phone: subcontractorData.telefon,
      subcontractor_email: subcontractorData.email,
      //subcontractor_adress: r,
    },
  ];

  return (
    <>
      <OrdersContainer>
        <ViewNavigation>
          <Redirect>
            <GoBackButton description={"Powrót"} />
          </Redirect>
        </ViewNavigation>
        <TableContainer>
          <StyledTable
            getRowId={(row) => row?.id}
            rows={rows}
            columns={columns}
            pageSize={1}
            hideFooter={true}
            autoHeight
          />
        </TableContainer>
      </OrdersContainer>
    </>
  );
};
const OrdersContainer = styled.div`
  width: 100%-300px;
  display: flex;
  flex-direction: column;
  margin-left: ${window.screen.width > 1024 ? "350px" : "0"};
  padding-right: ${window.screen.width > 1024 ? "50px" : "0"};
`;
const TableContainer = styled.div``;
const ViewNavigation = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 340px) {
    flex-direction: column;
  }
`;

const Redirect = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
`;
